import './block.png';
import './block_mobile.png';
import './exclamacao.png';
import './index.scss';
import 'components/empty_list_message';
import 'styles/components/_responsive-embed.scss';
import 'utils/favorites_toggle';
import Lesson from 'pages/lessons/components/lesson';

(function ($) {
  'use strict';

  $(document)
    .off('componentLoaded:questions/question_lessons')
    .on('componentLoaded:questions/question_lessons', (e, data) => {
      // Solução temporária

      const browserIsChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      const collapsibleLessons = $('.js-lesson .js-collapsible-content');

      if (browserIsChrome) {
        collapsibleLessons.collapse('show');
      }

      $('.js-lesson', data.context).each((i, el) => {
        el.lesson = new Lesson($(el));
      });

      const redirect_mesa = () => {
        const buttonElement = document.getElementById(
          'link_go_to_ils_blocked_lessons'
        );

        if (buttonElement) {
          const url = buttonElement.getAttribute('name');
          const question_id = buttonElement.getAttribute('question_id');

          const timestamp = new Date().getTime();
          let search = location.search.slice(1, location.search.length);

          if (!search) {
            search += 'my_questions=all';
          }

          const ils_complete_url = `${url}playground/questoes?lesson_question_id=${question_id}&${search}&timestamp=${timestamp}`;

          buttonElement.href = ils_complete_url;
        }
      };

      redirect_mesa();
    });
})(jQuery);
